<!--Login form-->

<div
	class="form-box shadow-noe flex justify-around" id="login">
		<div class="logo flex flex-col justify-center items-start m-4 z-1">
			<div class="logo-container flex flex-col justify-center items-end">
            <img height="52px" alt="FireRIS" src="../../assets/images/{{ logo }}" />
            <span class="relative -top-1.5 text-sm font-medium">v2.4.3</span>
        </div>
		</div>


	<form
		name="login-form"
        [formGroup]="form"
		class="flex flex-col p-4 z-1">
	 <!--username field-->
                <mat-form-field [style.width.px]="320">
                    <mat-label>{{ 'USERNAME' | translate }}</mat-label>
                    <input
                        [placeholder]="'USERNAME' | translate"
                        formControlName="username"
                        matInput
                        [required]="true" />
                    <mat-icon fontIcon="mdi-account-outline" fontSet="mdi" matIconPrefix></mat-icon>
                </mat-form-field>

                <!--password field-->
                <mat-form-field [style.width.px]="320">
                    <mat-label>{{ 'PASSWORD' | translate }}</mat-label>
                    <input
                        [placeholder]="'PASSWORD' | translate"
                        [type]="hide ? 'password' : 'text'"
                        formControlName="password"
                        matInput
                        [required]="true" />
                    <mat-icon
                        (click)="hide = !hide"
                        [fontIcon]="hide ? 'mdi-eye-off' : 'mdi-eye'"
                        fontSet="mdi"
                        matIconSuffix></mat-icon>
                    <mat-icon fontIcon="mdi-lock-outline" fontSet="mdi" matIconPrefix></mat-icon>
                </mat-form-field>
                 <mat-form-field [style.width.px]="320">
                    <mat-label>{{ 'IMAGING_CENTER' | translate }}</mat-label>
                    <mat-select
                        [(ngModel)]="selectedCenter"
                        [ngModelOptions]="{ standalone: true }"
                        [placeholder]="'IMAGING_CENTER' | translate">
                        @for (center of centers; track $index) {
                            <mat-option [value]="center"> {{ center.name }}</mat-option>
                        }
                    </mat-select>
                    <mat-icon fontIcon="mdi-map-marker-outline" fontSet="mdi" matIconPrefix></mat-icon>
                </mat-form-field>

               @if (errorMsg) {
                <span class="error">{{ errorMsg }}</span>
            }


		<div class="flex justify-end gap-4 pt-4 items-center">
		  <button (click)="onSubmit()" [disabled]="form.invalid" color="primary" matButton>
                {{ 'LOGIN' | translate }}
            </button>
		</div>
	</form>
</div>
<div class="login-footer w-full flex justify-between items-center py-4 px-8 gap-4">
  <img src="assets/images/firethunder.png" alt="firethunder.ma" height="40">

  <div class="flex items-center gap-1 w-fit">
    <span> {{ 'licence.to' | translate }}:</span>
    <span class="licenced-to"> {{ licencedTo() | uppercase }} </span>
  </div>


</div>

